import { Divider } from "@outschool/backpack";
import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useActivityCardTeacherListings } from "@outschool/ui-components-website";
import { Space } from "@outschool/ui-legacy-component-library";
import React from "react";

import { CdpMobileListingCarouselComponent } from "../../listings/carousels/CdpMobileListingCarousel";

export const MoreSameTeacherListingCarousel = ({
  activity,
  teacherName,
  carouselRowNum,
}: {
  activity: ClassDetailsNoSectionsQuery["activity"];
  teacherName: string;
  carouselRowNum: number;
}) => {
  const { t } = useTranslation(
    "client\\components\\detailPage\\mobileBelowClassDetail",
  );

  const teacherListings = useActivityCardTeacherListings(activity);

  const hasUpsellListing =
    !!teacherListings?.length &&
    teacherListings[0].activity.uid === activity.upsell_activity_uid;

  const moreTeacherListings =
    hasUpsellListing && teacherListings?.length > 1
      ? teacherListings.slice(1)
      : teacherListings;

  return (
    <>
      {!!moreTeacherListings?.length && (
        <>
          <Space y={14} />
          <CdpMobileListingCarouselComponent
            listings={moreTeacherListings}
            carouselRowNum={carouselRowNum++}
            title={t("Other classes by {{teacherName}}", {
              teacherName: teacherName,
            })}
          />
          <Divider sx={{ borderColor: "gray100", marginTop: "2.4rem" }} />
        </>
      )}
    </>
  );
};
